import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 17,
  small: 14,
  xSmall: 9
};
const AddToProjectIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M15.5 16V18H14.5V16H12.5V15H14.5V13H15.5V15H17.5V16H15.5Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.5 9H14.5L13.5 7H6.5V22H23.5V9ZM7.5 8H12.881L13.882 10H22.5V21H7.5V8Z",
        fill: "currentColor"
      }
    )
  );
};
AddToProjectIcon.iconName = "AddToProjectIcon";

export { AddToProjectIcon };
